import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RouterOutlet } from '@angular/router';
import { MobileNotificationComponent } from './shared/app-mobile-notification/app-mobile-notification.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, MobileNotificationComponent],
  standalone: true
})
export class AppComponent implements OnInit {
  private translate = inject(TranslateService);

  ngOnInit(): void {
    const savedLang = localStorage.getItem('app_language') || 'en';
    this.translate.setDefaultLang('en');
    this.translate.use(savedLang);
  }
}